module.exports = __webpack_public_path__ + "img/icon.3406f454.png";